import { TextField } from "@mui/material";
import React, { useCallback, useRef, useState } from "react";
import { SketchPicker } from 'react-color';
import "./styles.scss";

import useClickOutside from "./useClickOutside";
import { withStyles } from "@material-ui/styles";

export const PopoverPicker = ({ color, onChange }) => {
  const popover = useRef();
  const [isOpen, toggle] = useState(false);

  const CustomTextField = withStyles({
    root: {
      background: `linear-gradient(to right, #ffffff 80%, ${color} 0%)`,
      backgroundPosition: "right center",
      backgroundRepeat: "no-repeat",
    },
  })(TextField);

  const close = useCallback(() => toggle(false), []);
  useClickOutside(popover, close);

  return (
    <div className="picker">
      <CustomTextField
        className="swatch"
        value={color}
        onClick={() => toggle(true)}
      />

      {isOpen && (
        <div className="popover" ref={popover}>
          <SketchPicker color={color} onChangeComplete={color=> {onChange(color)}} />
        </div>
      )}
    </div>
  );
};
